import React from 'react';
import { useState } from 'react';
import { configData } from "../config";

// The "... Jobs Can Be Found Almost Everywhere" list at the bottom of a "jobs in sports" page.
// jobs: { heading, items, image } - image (optional) is a picture under the list, on the
// Drupal site, that opens enlarged when clicked.
const JobsInSportsList = ({ jobs }) => {
    const [showImage, setShowImage] = useState(false);
    const image = jobs.image ? configData.DRUPAL_DOMAIN_URL + jobs.image : '';

    return (
        <div className="jobs-in-sports-list">
            <h2>{jobs.heading}</h2>
            <ul>
                {jobs.items.map((job, idx) => <li key={idx}>{job}</li>)}
            </ul>

            {image && (
                <p className="jobs-in-sports-list__image">
                    <img src={image} alt="" loading="lazy" onClick={() => setShowImage(true)} />
                </p>
            )}

            {/* The enlarged picture: a click anywhere closes it */}
            {showImage && (
                <div className="jobs-in-sports-list__modal" onClick={() => setShowImage(false)}>
                    <span className="jobs-in-sports-list__close">×</span>
                    <img src={image} alt="" />
                </div>
            )}
        </div>
    );
};

export default JobsInSportsList;
